import svgIcons from "../../../assets/svg/svgIcons";
import HelpFeaturesVideo from "./helpFeaturesVideo";
import { forwardRef, memo } from "react";
import { HelpArticleBySectionResponse } from "../type";

interface HelpFeaturesContentProps {
    activeIndex: number;
    sectionArticle: HelpArticleBySectionResponse;
}

const HelpFeaturesContent = memo(forwardRef<HTMLDivElement, HelpFeaturesContentProps>(({ activeIndex, sectionArticle }, ref) => {
    const section = sectionArticle.steps.sections[activeIndex];

    return (
        <div className="flex-col gap-2 flex-1 bg-gray-100">
            <div className="p-2 bg-accent-blue-paleO66 rounded-md">
                <h2 className="text-2xl font-semibold m-2 text-accent-blue-dark">{section.title}</h2>
                <p className="text-gray-700 text-sm m-2">{section.Description}</p>
            </div>

            <section className="w-full px-10 py-5 pb-10">
            <HelpFeaturesVideo videoData={sectionArticle.help_article_video} />

                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-8">
                    <div className="space-y-10" ref={ref}>
                        {section.sub_section.map((sub, index) => (

                            <div key={index} data-subsection={sub.title}>
                                <h2 className="text-xl font-semibold text-accent-blue-dark mb-4 pl-3">
                                    {sub.title}
                                </h2>

                                {sub.is_numbered_bulleting ? (
                                    <ol className="space-y-4">
                                        {sub.content.map((item: string, index: number) => (
                                            <li key={index} className="flex items-start gap-4">
                                                <span className="flex items-center justify-center w-7 h-7 rounded-md bg-gray-200 text-accent-blue-bright text-sm font-semibold shrink-0">
                                                    {index + 1}
                                                </span>

                                                <div
                                                    className="text-gray-800"
                                                    dangerouslySetInnerHTML={{ __html: item }}
                                                />
                                            </li>
                                        ))}
                                    </ol>
                                ) : (
                                    <ul className="space-y-4">
                                        {sub.content.map((item: string, index: number) => (
                                            <li key={index} className="flex items-start gap-3">
                                                <img src={svgIcons.RightArrowGrey} alt="Arrow" className="text-gray-500 m-1" />

                                                <div
                                                    className="text-gray-800"
                                                    dangerouslySetInnerHTML={{ __html: item }}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                )}

                            </div>
                        ))}
                    </div>

                    <div className="space-y-6">
                        <div className="bg-accent-blue-verydark rounded-xl p-6 text-white">
                            <h3 className="font-semibold text-md mb-3">
                                Still Need Help?
                            </h3>
                            <p className="text-sm leading-6 text-blue-100">
                                Our team is available 24/7 for tailored technical support and complex solution architecture.
                                Call our Technical Services Team at{" "}
                                <span className="font-semibold text-white">
                                    844-291-7514
                                </span>.
                                We're here to help!
                            </p>
                        </div>

                    </div>
                </div>
            </section>

        </div>
    )
}));
export default HelpFeaturesContent;